import * as types from '../actions/types';
import initialState from './initialState';

export default function loginReducer(state = initialState.login, action) {
  switch (action.type) {
    case types.LOGIN_USER_REQUEST:
      return {
        ...state,
        'isAuthenticating': true,
        'statusText': null
      };
    case types.LOGIN_USER_SUCCESS:
      return {
        ...state,
        'isAuthenticating': false,
        'isAuthenticated': true,
        'token': action.payload.token,
        'statusText': 'You have been successfully logged in.'
      };
    case types.LOGIN_USER_FAILURE:
      return {
        ...state,
        'isAuthenticating': false,
        'isAuthenticated': false,
        'token': null,
        'statusText': `Authentication Error: ${action.payload.status} ${action.payload.statusText}`
      };
    case types.LOGOUT_USER:
      return {
        ...state,
        'isAuthenticated': false,
        'token': null,
        'statusText': 'You have been successfully logged out.'
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js